import React from 'react'
import axios from 'axios'
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useEffect, useState } from 'react'
import { Button } from "flowbite-react";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon, TrashIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormSolution from './FormSolution';
import LoadingSpinner from '../../components/LoadingSpinner';

const Solutions = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [solutionId, setSolutionId] = useState(null);
    const [idSolution, setIdSolution] = useState(null);
    const [solutions, setSolutions] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const openModal = (title,solutionId,editMode) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setSolutionId(solutionId);
        setIsCreating(editMode);
    };
    const handleFormSubmit = async(data) => {
        
        let name = data.name == "";
        if(name){ alert("Ingrese la solución"); return;}

        let description = data.description == "";
        if(description){ alert("Ingrese la descripción"); return;}

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}

        setIsLoading(true);
        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solution/create`,
                data,
                {
                    withCredentials: true,
                }
            );
            if(response.status){
                setSolutions([...solutions, response.data.new_solution]);
                alert("Solución creada correctamente!");
            }else{
                alert("Ocurrio un problema al almacenar la solución");                
            }
        } catch (error) {
            alert("error al crear la solución");
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solution/${solutionId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );

            console.log("solutionId",solutionId);
            setSolutions(
                solutions.map((solution) =>
                    solution.id === solutionId ? { ...solutions, ...response2.data.solution } : solution
                )
            ); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('confirma la eliminación de la solución ?');
        if (!confirma) return;
        setIsLoading(true);
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solution/${id}/delete`,
                {
                    withCredentials: true,
                }
            );

            if(response.data.status == "OK"){
                setSolutions(solutions.filter((solution) => solution.id !== id));
                alert("La solución se elimino correctamente");
            }else if(response.data.status =="ERROR"){
                alert("Existe un problema en la eliminación de la solución: "+ response.data.e);
            }

        }catch(error){
            
        } finally{
            setIsLoading(false);
        }
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedList = Array.from(solutions);
        const [movedItem] = reorderedList.splice(result.source.index, 1);
        reorderedList.splice(result.destination.index, 0, movedItem);

        setSolutions(reorderedList);
        
        const list = [];
        reorderedList.forEach((row)=>{
            list.push({'id':row.id,'order':row.row_order});
        });
        console.log(list );
        handleUpdateOrder(list);
    };

    const handleUpdateOrder = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solution/${idSolution}/reordered`,
                data,
                {
                    withCredentials: true,
                }
            );

            setSolutions(response2.data.solutions); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    }

    useEffect(()=>{
        const getSolutions = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/solutions`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setSolutions(response.data);
            } catch (error) {
                setError(error.message);
            } finally{
                setIsLoading(false);
            } 
        }
        
        getSolutions();

        setIdSolution(solutionId);
    },[solutionId]);

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="p-2 mt-4 flex justify-between">
                <h1 className="text-xl mb-2 px-3 flex-col">Soluciones</h1>
                <div className="flex justify-end">
                    <Button className="text-gray-600" onClick={()=>openModal("Soluciones",null,true)} color='gray'>Crear</Button>
                </div>
                {error && <div className="text-red-500">{error}</div>}
            </div>

            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="solution">
                    {(provided) => (
                        <ul ref={provided.innerRef} {...provided.droppableProps} className="space-y-2 ">
                            {solutions?.map((sol, index) => (
                                <Draggable key={sol.id} draggableId={sol.id.toString()} index={index}>
                                    {(provided) => (
                                        <li
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className="p-4 bg-gray-100 rounded-md shadow cursor-grab text-gray-700 dark:text-gray-400 bg-white"
                                        >
                                            <div className="flex">
                                                <div className="w-full">
                                                    <p className="text-gray-900 font-semibold">{sol.name}</p>
                                                    <p className="text-gray-400">{sol.description}</p>
                                                </div>
                                                <div className="flex">
                                                    <a href="#" onClick={()=>openModal("Soluciones",sol.id, false)}>
                                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar Solución"/>
                                                    </a>
                                                    <a href="#" onClick={()=>handleRemove(sol.id)}>
                                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar Solución"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>



            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"md"}>
                <FormSolution onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} onClose={closeModal} solutionId={solutionId} />
            </Modals>
        </>
  )
}

export default Solutions
